// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 599px) {
  .order-widgets {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .order-widgets {
    width: 50%;
  }
}
.order-widgets .mat-mdc-dialog-container {
  padding: 0;
}
.order-widgets .dialog-content-wrapper {
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}
.order-widgets .primary-color-input,
.order-widgets .secondary-color-input {
  padding: 6px 8px;
}

order-widgets img {
  vertical-align: top;
  border: none;
  height: 50px;
}
order-widgets .example-list {
  width: 500px;
  max-width: 100%;
  border: solid 1px #ccc;
  min-height: 60px;
  display: block;
  background: white;
  border-radius: 4px;
  overflow: hidden;
}
order-widgets .example-box {
  padding: 10px 10px;
  border-bottom: solid 1px #ccc;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
}

.drag-drop-container .cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.drag-drop-container .cdk-drag-placeholder {
  opacity: 0;
}
.drag-drop-container .cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.drag-drop-container .example-box:last-child {
  border: none;
}
.drag-drop-container .example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}`, "",{"version":3,"sources":["webpack://./src/@fuse/scss/partials/_breakpoints.scss","webpack://./src/app/main/dashboard/home/order-widgets/order-widgets.component.scss"],"names":[],"mappings":"AAiCQ;EC/BR;IAGQ,WAAA;EAFN;AACF;AD6BQ;EC/BR;IAOQ,UAAA;EADN;AACF;AAGI;EACI,UAAA;AADR;AAII;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;AAFR;AAKI;;EAEI,gBAAA;AAHR;;AAQI;EACI,mBAAA;EACA,YAAA;EACA,YAAA;AALR;AAQI;EACI,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AANR;AASI;EACI,kBAAA;EACA,6BAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAPR;;AAYI;EACI,sBAAA;EACA,kBAAA;EACA,qHAAA;AATR;AAcI;EACI,UAAA;AAZR;AAeI;EACI,sDAAA;AAbR;AAgBI;EACI,YAAA;AAdR;AAiBI;EACI,sDAAA;AAfR","sourcesContent":["// Media step breakpoint mixin based on Angular Material lib\n$breakpoints: (\n    xs: 'screen and (max-width: 599px)',\n    sm: 'screen and (min-width: 600px) and (max-width: 959px)',\n    md: 'screen and (min-width: 960px) and (max-width: 1279px)',\n    lg: 'screen and (min-width: 1280px) and (max-width: 1919px)',\n    xl: 'screen and (min-width: 1920px) and (max-width: 5000px)',\n    lt-sm: 'screen and (max-width: 599px)',\n    lt-md: 'screen and (max-width: 959px)',\n    lt-lg: 'screen and (max-width: 1279px)',\n    lt-xl: 'screen and (max-width: 1919px)',\n    gt-xs: 'screen and (min-width: 600px)',\n    gt-sm: 'screen and (min-width: 960px)',\n    gt-md: 'screen and (min-width: 1280px)',\n    gt-lg: 'screen and (min-width: 1920px)'\n) !default;\n\n// Re-map the breakpoints for the helper classes\n$helper-breakpoints: (\n    xs: null,\n    sm: 'gt-xs',\n    md: 'gt-sm',\n    lg: 'gt-md',\n    xl: 'gt-lg'\n);\n\n@mixin media-breakpoint($breakpointName) {\n\n    $mediaQuery: map-get($breakpoints, $breakpointName);\n\n    @if ($mediaQuery == null) {\n        @content\n    } @else {\n        @media #{$mediaQuery} {\n            @content\n        }\n    }\n}\n","@import \"src/@fuse/scss/partials/breakpoints\";\n\n.order-widgets {\n\n    @include media-breakpoint('xs') {\n        width: 100%;\n    }\n\n    @include media-breakpoint('gt-xs') {\n        width: 50%;\n    }\n\n    .mat-mdc-dialog-container {\n        padding: 0;\n    }\n\n    .dialog-content-wrapper {\n        max-height: 85vh;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .primary-color-input,\n    .secondary-color-input {\n        padding: 6px 8px;\n    }\n}\n\norder-widgets {\n    img {\n        vertical-align: top;\n        border: none;\n        height: 50px;\n    }\n\n    .example-list {\n        width: 500px;\n        max-width: 100%;\n        border: solid 1px #ccc;\n        min-height: 60px;\n        display: block;\n        background: white;\n        border-radius: 4px;\n        overflow: hidden;\n    }\n\n    .example-box {\n        padding: 10px 10px;\n        border-bottom: solid 1px #ccc;\n        color: rgba(0, 0, 0, 0.87);\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        box-sizing: border-box;\n        cursor: move;\n        background: white;\n        font-size: 14px;\n    }\n}\n\n.drag-drop-container {\n    .cdk-drag-preview {\n        box-sizing: border-box;\n        border-radius: 4px;\n        box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\n            0 8px 10px 1px rgba(0, 0, 0, 0.14),\n            0 3px 14px 2px rgba(0, 0, 0, 0.12);\n    }\n\n    .cdk-drag-placeholder {\n        opacity: 0;\n    }\n\n    .cdk-drag-animating {\n        transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n    }\n\n    .example-box:last-child {\n        border: none;\n    }\n\n    .example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {\n        transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
